
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Adapter vos campagnes Google Ads aux différents appareils",
    description:
      "Optimisez vos campagnes Google Ads pour mobile, desktop et tablette avec ALEO. Découvrez comment ajuster vos annonces pour chaque support et maximiser votre ROI.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
